import type { EventProperties } from '@segment/analytics-next';

import type { PopAccuracyComfortSectionData } from '../PopAccuracyComfort/types';

const VIDEO_CTA_ANALYTICS_PROPERTIES: EventProperties = {
  cta: 'discover oura ring 4',
  action: 'play_video',
  location: 'pop hero',
};

const accuracyComfortSections: PopAccuracyComfortSectionData[] = [
  {
    highlights: [
      {
        copy: 'pop_gen4_accuracy_tab_1_copy',
        title: 'pop_gen4_accuracy_tab_1_title',
      },
      {
        copy: 'pop_gen4_accuracy_tab_2_copy',
        title: 'pop_gen4_accuracy_tab_2_title',
      },
      {
        copy: 'pop_gen4_accuracy_tab_3_copy',
        title: 'pop_gen4_accuracy_tab_3_title',
      },
    ],
    id: 'accuracy',
    shouldScrollAnimateBg: true,
    theme: {
      sm: 'light',
      md: 'dark',
    },
    title: 'pop_gen4_accuracy_title',
    titleClassName: 'max-w-[400px] md:max-w-[500px] lg:max-w-[700px]',
    videoBg: {
      fallback: {
        srcSet: [
          {
            media: '(max-width: 767px)',
            src: 'blue-sky/pop/gen4/accuracy-bg-fallback.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.44&fp-y=0.56&fp-z=1.6',
          },
          {
            media: '(min-width: 768px)',
            src: 'blue-sky/pop/gen4/accuracy-bg-fallback.jpg',
          },
        ],
      },
      poster: 'blue-sky/pop/gen4/OMA_PoP_Video_240924_v005_HD_1_poster.png',
      srcSet: [
        {
          src: 'blue-sky/pop/gen4/OMA_PoP_Video_240924_v005_HD_1.mp4',
        },
      ],
    },
    videoCta: {
      analyticsProperties: {
        ...VIDEO_CTA_ANALYTICS_PROPERTIES,
        module: 'smart_sensing_video',
      },
      label: 'pop_gen4_accuracy_video_cta',
    },
    videoFeature: {
      captions: [
        { lang: 'cs', src: 'smart-sensing-cs.vtt' },
        { lang: 'da', src: 'smart-sensing-da.vtt' },
        { lang: 'de', src: 'smart-sensing-de.vtt' },
        { lang: 'en', src: 'smart-sensing-en.vtt' },
        { lang: 'es', src: 'smart-sensing-es.vtt' },
        { lang: 'fi', src: 'smart-sensing-fi.vtt' },
        { lang: 'fr', src: 'smart-sensing-fr.vtt' },
        { lang: 'it', src: 'smart-sensing-it.vtt' },
        { lang: 'ja', src: 'smart-sensing-ja.vtt' },
        { lang: 'nb', src: 'smart-sensing-nb.vtt' },
        { lang: 'nl', src: 'smart-sensing-nl.vtt' },
        { lang: 'sv', src: 'smart-sensing-sv.vtt' },
      ],
      contentTitle: 'Smart Sensing Film',
      location: 'pop-gen4-accuracy-section',
      src: 'blue-sky/pop/gen4/smart-sensing-final.mp4',
      type: 'video/mp4',
    },
  },
  {
    contentIntroTransitionDelay: {
      sm: 0.25,
      md: 3.25,
    },
    highlights: [
      {
        copy: 'pop_gen4_comfort_tab_1_copy',
        title: 'pop_gen4_comfort_tab_1_title',
      },
      {
        copy: 'pop_gen4_comfort_tab_2_copy',
        title: 'pop_gen4_comfort_tab_2_title',
      },
      {
        copy: 'pop_gen4_comfort_tab_3_copy',
        title: 'pop_gen4_comfort_tab_3_title',
      },
    ],
    id: 'comfort',
    shouldScrollAnimateBg: false,
    theme: {
      sm: 'light',
      md: 'light',
    },
    title: 'pop_gen4_comfort_title',
    titleClassName: 'max-w-[275px] md:max-w-[345px] lg:max-w-[480px]',
    videoBg: {
      fallback: {
        srcSet: [
          {
            media: '(max-width: 767px)',
            src: 'blue-sky/pop/gen4/comfort-bg-fallback.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.6&fp-z=1.3',
          },
          {
            media: '(min-width: 768px)',
            src: 'blue-sky/pop/gen4/comfort-bg-fallback.jpg',
          },
        ],
      },
      poster: 'blue-sky/pop/gen4/OMA_PoP_Video_240924_v005_HD_2_poster.png',
      srcSet: [
        {
          src: 'blue-sky/pop/gen4/OMA_PoP_Video_240924_v005_HD_2.mp4',
        },
      ],
    },
    videoCta: {
      analyticsProperties: {
        ...VIDEO_CTA_ANALYTICS_PROPERTIES,
        module: 'how_its_made_video',
      },
      label: 'pop_gen4_comfort_video_cta',
    },
    videoFeature: {
      captions: [
        { lang: 'cs', src: 'oura-craft-film-cs.vtt' },
        { lang: 'da', src: 'oura-craft-film-da.vtt' },
        { lang: 'de', src: 'oura-craft-film-de.vtt' },
        { lang: 'en', src: 'oura-craft-film-en.vtt' },
        { lang: 'es', src: 'oura-craft-film-es.vtt' },
        { lang: 'fi', src: 'oura-craft-film-fi.vtt' },
        { lang: 'fr', src: 'oura-craft-film-fr.vtt' },
        { lang: 'it', src: 'oura-craft-film-it.vtt' },
        { lang: 'ja', src: 'oura-craft-film-ja.vtt' },
        { lang: 'nb', src: 'oura-craft-film-nb.vtt' },
        { lang: 'nl', src: 'oura-craft-film-nl.vtt' },
        { lang: 'sv', src: 'oura-craft-film-sv.vtt' },
      ],
      contentTitle: `How It's Made`,
      location: 'pop-gen4-comfort-section',
      localizedSrc: 'craft_film_video',
      type: 'video/mp4',
    },
  },
];

export default accuracyComfortSections;
